import { NEW_PRM_URL, OLD_PRM_URL } from 'lib/participants/Constants'

type GetParticipantsRoute = {
  hasNewPRMSwitchedOn: boolean
}

export const getParticipantsRoute = ({
  hasNewPRMSwitchedOn,
}: GetParticipantsRoute) => {
  if (hasNewPRMSwitchedOn) {
    return NEW_PRM_URL
  }

  return OLD_PRM_URL
}
